import React from 'react';
import { Button, Collapse, Input, Progress, Table } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { getClaims, getLoggedInUserName, RRServer } from '../../../utils/lib';
import { UserInterface, PaymentInterface } from '../../../types';

// import Razorpay from "razorpay";
// import logo from "../../logo.svg";
import { Select } from 'antd';
import dayjs from 'dayjs';
import TopBar from '../../TopBar';
import TableContainer from '../../TableComp/TableContainer';

const { Option } = Select;
const { Panel } = Collapse;

interface DrivingSchoolInterface {
    code: string;
    id: string
    drivingSchoolName: string
    currentCount: string
    pricePerCode: number
    codesRemaining: number
}
interface CorporateInterface {
    code: string;
    id: string
    corporateName: string
    currentCount: string
}
interface CorporateCodesInterface {
    code: string;
    password: string;
}


type schoolHashedType = { [key: string]: DrivingSchoolInterface };
type corporateHashedType = { [key: string]: CorporateInterface };
type corporateCodesHashedType = { [key: string]: CorporateCodesInterface };
interface UserStateProps {
    schools: DrivingSchoolInterface[],
    schoolsHashed: schoolHashedType

    corporates: CorporateInterface[],
    corporatesHashed: corporateHashedType

    selectedSchool: DrivingSchoolInterface | null
    userCode: string
    users: UserInterface[]

    corporateCodes: CorporateCodesInterface[],
    corporateCodesHashed: corporateCodesHashedType


    filterSchoolId: string

    codesToBuy: number,
    payments: PaymentInterface[],

    loading: boolean,
    isSearch: boolean,
    isToggle: boolean,
    isTableShow: boolean,
    purchaseValue: number,
    percent: number
}

class PurchaseClone extends React.Component<any, UserStateProps> {
    constructor(props: any) {
        super(props);
        this.state = {
            schools: [],
            schoolsHashed: {},
            corporates: [],
            corporatesHashed: {},
            selectedSchool: null,
            userCode: '',
            users: [],
            corporateCodes: [],
            corporateCodesHashed: {},
            filterSchoolId: '',
            codesToBuy: 5,
            payments: [],
            loading: false,
            isSearch: true,
            isToggle: false,
            isTableShow: false,
            purchaseValue: 50,
            percent: 0
        }
        this.getSchool = this.getSchool.bind(this);


    }

    componentDidMount() {
        //         const companyId=getUse
        this.getData('');

    }

    componentDidUpdate(prevProps: any) {

        if (this.props.drivingSchool !== prevProps.drivingSchool) {
            console.log('Props changed', this.props)
            this.getData(this.props.drivingSchool.id);
        }
    }

    getData = (id: string) => {

        getClaims().then(claims => {
            if (!claims || !!!claims['drivingSchoolId']) { return null }
            const drivingSchoolId = claims ? claims['drivingSchoolId'] : '';

            const userPromise = drivingSchoolId === '*'
                ? RRServer.list({ table: 'users', forCurrentUser: false })
                : RRServer.list({ table: 'users', forCurrentUser: false, where: [['companyId', '==', drivingSchoolId]] });
            const dsPromise = drivingSchoolId === '*'
                ? RRServer.list({ table: RRServer.Tables.DRIVING_SCHOOLS, forCurrentUser: false })
                : RRServer.get({ table: RRServer.Tables.DRIVING_SCHOOLS, id: drivingSchoolId });

            const paymentsPromise = RRServer.list({ table: 'payments', forCurrentUser: false, where: [['schoolId', '==', drivingSchoolId]] })



            Promise.all([
                // RRServer.list({ table: 'users', forCurrentUser: false, where:[['companyId','==',id]] }),
                userPromise,
                dsPromise,
                paymentsPromise,
                RRServer.list({ table: 'corporate_users', forCurrentUser: false }),
                RRServer.list({ table: 'corporate_codes', forCurrentUser: false }),
            ])
                .then((results: any) => {
                    let payments = results[2].data.data;
                    let schools: DrivingSchoolInterface[];
                    let _s:schoolHashedType={}
                    if (results[1].data.data) {
                        schools = results[1].data.data.length ? results[1].data.data : [results[1].data.data];
                         _s = {};
                        schools.map(school => _s[school.id] = school)
                    } else {
                        schools = [];
                    }

                    let corporates: CorporateInterface[] = results[3].data.data;
                    let _c: corporateHashedType = {};
                    corporates.map(corp => _c[corp.id] = corp)

                    let corporateCodes: CorporateCodesInterface[] = results[4].data.data;
                    let _cc: corporateCodesHashedType = {};
                    corporateCodes.map(corp => _cc[corp.code] = corp)

                    this.setState({ schools, schoolsHashed: _s, payments, corporates, corporatesHashed: _c, corporateCodes, corporateCodesHashed: _cc })
                });


        })
    }

    getSchool(schoolId: string) {
        const school = this.state.schools.filter(school => school.id = schoolId);
        return school[0];
    }

    getName = (user: UserInterface) => {
        if (!user) { return 'NU' }
        const { schoolsHashed, corporatesHashed } = this.state;
        if (user.type === 'DRIVING_SCHOOL') {
            const _school = schoolsHashed[user.companyId];
            return (_school && _school.drivingSchoolName);
        } else if (user.type === 'CORPORATE_USER_IOCL') {
            const _corp = corporatesHashed[user.companyId];
            return (_corp && _corp.corporateName);
        }
    }

    getPassword = (user: UserInterface) => {
        if (user.password) {
            return user.password;
        }
        const { corporateCodesHashed } = this.state;
        const cc = corporateCodesHashed[user.code];
        return cc ? cc.password : '-';
    }

    loadScript(src: string) {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    }

    createOrder = async () => {
        const { schools, codesToBuy } = this.state;
        const pricePerCode = schools[0].pricePerCode;

        if (!pricePerCode) {
            alert('Price Per Code Not Set');
            return;
        }

        return RRServer.callFn('payment-createOrder', {
            pricePerCode: pricePerCode, codes: codesToBuy
        })
            .then((r: any) => r.data.order)

    }

    displayRazorpay = async () => {
        const { schools, codesToBuy } = this.state;

        const res = await this.loadScript(
            "https://checkout.razorpay.com/v1/checkout.js"
        );

        if (!res) {
            alert("Razorpay SDK failed to load. Are you online?");
            return;
        }

        this.setState({ loading: true })


        // creating a new order
        const result = await this.createOrder();
        console.log(result);

        if (!result) {
            alert("Server error. Are you online?");
            return;
        }

        // // Getting the order details back
        const { amount, id: order_id, currency } = result;
        const name = getLoggedInUserName();

        const options = {
            key: "rzp_live_bfig0kGIyXdE7J", // Enter the Key ID generated from the Dashboard
            amount: amount.toString(),
            currency: currency,
            name: name,
            description: "Roadrakshak User Codes",
            // image: { logo },
            order_id: order_id,
            handler: async (response: any) => {
                const data = {
                    orderCreationId: order_id,
                    razorpayPaymentId: response.razorpay_payment_id,
                    razorpayOrderId: response.razorpay_order_id,
                    razorpaySignature: response.razorpay_signature,
                    codes: codesToBuy,
                    companyId: schools[0].id,
                    userCode: schools[0].code
                };

                RRServer.callFn('payment-verifyOrder', data)
                    .then((r: any) => {
                        console.log('Success', r);
                        // alert(result.data.msg);
                        if (r.data.s) {

                            RRServer.add({
                                table: 'payments', data: {
                                    razorpayPaymentId: response.razorpay_payment_id,
                                    razorpayOrderId: response.razorpay_order_id,
                                    amount,
                                    codesToBuy,
                                    pricePerCode: schools[0].pricePerCode,
                                    schoolId: schools[0].id,
                                    schoolName: schools[0].drivingSchoolName
                                }
                            });
                            const codesRemaining = schools[0].codesRemaining || 0;
                            RRServer.update({ table: RRServer.Tables.DRIVING_SCHOOLS, id: schools[0].id, codesRemaining: codesRemaining + codesToBuy });
                            alert('Payment Successful');

                            this.setState({ loading: false })
                            window.location.reload()
                        }

                    })

            },
            prefill: {
                name: name,

            },
            notes: {

            },
            theme: {
                color: "#61dafb",
            },
        };

        const paymentObject = new (window as any).Razorpay(options);
        paymentObject.open();
    }

    subtractCodes = () => this.setState({ codesToBuy: this.state.codesToBuy == 5 ? 5 : this.state.codesToBuy - 5 })
    addCodes = () => this.setState({ codesToBuy: this.state.codesToBuy + 5 })

    
    increase = () => {
        let percent = this.state.percent + 5;
        if (percent > 100) {
            percent = 100;
        }
        this.setState({ percent });
    };

    decline = () => {
        let percent = this.state.percent - 5;
        if (percent < 0) {
            percent = 0;
        }
        this.setState({ percent });
    };

    handleShowTable = () => {
        this.setState({ isTableShow: !this.state.isTableShow });
    }


    render() {

        const { payments, filterSchoolId, codesToBuy, schools } = this.state;
        // let { url } = this.props.match;


        const claimsString = localStorage.getItem('claims') || '{}';
        const claims = JSON.parse(claimsString);
        claims.drivingSchoolId = claims.drivingSchoolId || '';
        const currentSchool: DrivingSchoolInterface = schools[0];

        let dataSource = payments.map(payment => ({ key: payment.id, ...payment , addedOn: new Date(payment.addedOn).toLocaleString("en-US").split(",")[0], time: new Date(payment.addedOn).toLocaleString("en-US").split(",")[1], amount: payment.amount/100}))

        const columns = [
            {
                Header: 'Amount',
                accessor: 'amount',
                // disableSortBy: true
                disableFilters: true,
            },
            {
                Header: 'Price per Code',
                accessor: 'pricePerCode',
                disableFilters: true
            },

            {
                Header: 'Codes Purchased',
                accessor: "codesToBuy",
                disableFilters: true
        
            },
            {
                Header: 'Added On',
                accessor: "addedOn",
                disableFilters: true
        
            },
            {
                Header: 'Time',
                accessor: "time",
                disableFilters: true
            }
        ]
       

        const purchased = payments.reduce((a, b: PaymentInterface) => Number(b.codesToBuy) + a, 0);
        const remaining = currentSchool ? currentSchool.codesRemaining : 0;
        const used = purchased - remaining;

        return (
            <>
                <TopBar title="Purchase" />

                <div className='contentContainer d-flex flex-direction-row' style={{ height: "80vh", flexDirection: "row" }}>


                    <div className='sectionOne'>
                        <div className="purchaseCard">
                            <div className='purchaseCardTitle'>Status of Available codes</div>
                            <div className="content">
                                <Progress type="circle" percent={remaining} strokeWidth={15} strokeColor={'#FEC626'} format={percent => `${percent}`} />
                                <div className="progressBg">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="145" height="144" viewBox="0 0 135 134">
                                        <image id="Vector_Smart_Object11" data-name="Vector Smart Object11" x="2" y="2" width="100" height="100" xlinkHref="data:img/png;base64,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" />
                                    </svg>
                                </div>
                                <div className="progressFg">
                                    {/* <img src={plate} alt="White Base Circle" className="plate"/> */}
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="130" height="130" viewBox="0 0 135 134">
                                        <image id="Vector_Smart_Object11" data-name="Vector Smart Object11" x="2" y="2" width="100" height="100" xlinkHref="data:img/png;base64,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" />
                                    </svg>
                                </div>
                            </div>
                            <button className='purchase' onClick={() => this.setState({ isTableShow: !this.state.isTableShow })}>{!this.state.isTableShow ? 'Show History' : "Hide History"}  </button>
                        </div>
                        <div className="purchaseCard">
                            <p className='purchaseCardTitle'>New code purchase</p>
                            <div className="content">
                                <div className="progressLine">
                                    <Progress percent={this.state.percent} strokeColor={"#ee9b00"} format={percent => `${percent}`} style={{ color: "white" }} />
                                    <Button.Group>
                                        <Button onClick={this.decline} icon={<MinusOutlined />} />
                                        <Button onClick={this.increase} icon={<PlusOutlined />} />
                                    </Button.Group>
                                </div>
                            </div>
                            <button className='purchase'  type='button' onClick={this.displayRazorpay} /* style={{ position: "absolute", bottom: "10px" }} */>Purchase</button>
                        </div>
                    </div>  
                    {console.log('tabb', dataSource)}
                    
                    {this.state.isTableShow &&
                        <div className='sectionTwo' style={{ width: "60%", marginLeft: "30px", overflowY: "scroll" }}>
                            {<TableContainer columns={columns} data={dataSource} />}
                        </div>
                    }

                </div>



            </>
        );
    }
}

// export default withRouter(UserAdd);
export default PurchaseClone;